














import Vue from 'vue'
import BaseLayout from '@/layout/BaseLayout.vue'
import { ADD_TOAST_MESSAGE } from 'vuex-toast'
import CommonBack from '@/components/Common/CommonBack.vue'
import { mapActions } from 'vuex'
import { AxiosPromise } from 'axios'
import { SCRIPTS__MAKE_ACTION } from '@/store/actions'
import { ScriptActionPayload } from '@/models/scripts'
import { ScriptAction, ScriptPublishStatusMessages } from '@/constants/scripts'
import { RouteNames } from '@/router'

interface Data {
  title: string
}

interface Methods {
  [SCRIPTS__MAKE_ACTION](data: ScriptActionPayload): AxiosPromise
  create: (publish: boolean) => void
}

export default Vue.extend<Data, Methods, {}, {}>({
  components: {
    BaseLayout,
    CommonBack,
  },
  data() {
    return {
      title: '',
    }
  },
  methods: {
    ...mapActions([SCRIPTS__MAKE_ACTION]),
    create(publish: boolean): void {
      const { scriptId } = this.$route.params
      if (typeof this.title !== 'string' || this.title.length === 0) {
        ;(this.$refs.title as HTMLElement).focus()
        this.$store.dispatch(ADD_TOAST_MESSAGE, {
          text: this.$tc('version.nameError'),
          type: 'warning',
        })
        return
      }
      const payload: ScriptActionPayload = {
        id: scriptId,
        title: this.title,
        action: publish ? ScriptAction.PublishEdits : ScriptAction.SaveEdits,
      }

      this[SCRIPTS__MAKE_ACTION](payload).then(response => {
        const text =
          publish &&
          typeof response.data === 'object' &&
          response.data.published
            ? ScriptPublishStatusMessages[response.data.published]
            : this.$tc('version.saveSuccess')

        this.$store.dispatch(ADD_TOAST_MESSAGE, {
          text,
          type: 'success',
        })

        this.$router.push({
          name: RouteNames.ScriptPage,
          params: { scriptId, instanceId: response?.data?.instanceId },
        })
      })
    },
  },
  metaInfo() {
    return { title: this.$tc('version.saveTitle') }
  },
})
